import { api } from './apiServices'; // Assuming apiServices exports 'api'

export const getCouponsByStatus = (status) => {
  // The backend status values are DRAFT, ACTIVE, EXPIRED, ARCHIVED
  // We map our tab names to these values.
  const statusMap = {
    ACTIVE: "ACTIVE",
    EXPIRED: "EXPIRED",
    ARCHIVED: "ARCHIVED",
    DRAFT: "DRAFT",
  };
  const apiStatus = statusMap[status] || 'ACTIVE';
  return api.get('/admin/coupons', { params: { status: apiStatus } });
};

export const createCoupon = (data) => {
  return api.post('/admin/coupons', data);
};

export const getCouponById = (id) => {
  return api.get(`/admin/coupons/edit/${id}`);
};

export const updateCoupon = (id, data) => {
  return api.patch(`/admin/coupons/${id}`, data);
};

export const updateCouponStatus = (id, newStatus) => {
  return api.patch(`/admin/coupons/${id}/status`, { status: newStatus });
};

// Fetches the list of coin package templates for the form
export const getCoinPackageTemplates = () => {
  // As requested, we will filter out the "Welcome Set" on the frontend for this example.
  // Ideally, the API could accept a filter, e.g., /api/v1/coin-package-templates?is_welcome=false
  return api.get('/admin/coin-package-templates'); // Assuming you have an admin endpoint for this
};

export const duplicateCoupon = (id) => {
  return api.post(`/admin/coupons/${id}/duplicate`);
};

export const deleteDraftCoupon = (id) => {
  return api.delete(`/admin/coupons/${id}`);
};



// --- NEW: Functions for Super Admin Coupon Permissions ---

export const getCouponPermissions = () => {
  return api.get('/admin/coupons/coupon-permissions/');
};

export const createCouponPermission = (data) => {
  // data should be { coupon_id: int, admin_id: int | null, group_name: str | null }
  return api.post("/admin/coupons/coupon-permissions/", data);
};

export const deleteCouponPermission = (permissionId) => {
  return api.delete(`/admin/coupons/coupon-permissions/${permissionId}`);
};


// --- NEW: Function for CS Agent to Activate a Coupon ---

export const activateCouponForSeller = (sellerId, couponCode) => {
  return api.post(`/admin/coupons/sellers/${sellerId}/activate`, {
    coupon_code: couponCode,
  });
};

// NEW: Function to get a list of all admins for the permission form
export const getAllAdmins = () => {
    return api.get("/admin/users/all"); // Assuming an endpoint like this exists or can be created
};

export const getSellerActiveCoupons = (sellerId) => {
  return api.get(`/admin/coupons/${sellerId}/activated-coupons`);
};
